export * from './baSystemSvg.pipe';
